// import React, { useState } from 'react';
// import AnnouncementIcon from '@mui/icons-material/Announcement';
// import { TextField, IconButton } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';

// function ThirdCard() {
//   const [rule, setRule] = useState('');
//   const [rules, setRules] = useState([]);

//   const handleAddRule = (e) => {
//     if (e.key === 'Enter' && rule.trim() !== '') {
//       setRules([...rules, rule]);
//       setRule('');
//     }
//   };

//   const handleDeleteRule = (index) => {
//     setRules(rules.filter((_, i) => i !== index));
//   };

//   return (
//     <div className="p-4 flex flex-col h-full rounded-lg shadow-lg">
//       {/* Header */}
//       <div className="flex items-center justify-between mb-4">
//         <h1 className="text-2xl font-semibold">Rules</h1>
//         <AnnouncementIcon />
//       </div>

//       {/* Display Rules */}
//       <div className="flex flex-col space-y-2 flex-grow">
//         {rules.length > 0 ? (
//           rules.map((r, index) => (
//             <div key={index} className="flex justify-between items-center px-3 py-2 border border-gray-300 rounded-md">
//               <span>{r}</span>
//               <IconButton size="small" onClick={() => handleDeleteRule(index)}>
//                 <DeleteIcon fontSize="small" />
//               </IconButton>
//             </div>
//           ))
//         ) : (
//           <p className="text-gray-500">No rules added yet.</p>
//         )}
//       </div>

//       {/* Input Field (Placed Below) */}
//       <div className="mt-4">
//         <TextField
//           label="Add Rule"
//           variant="outlined"
//           fullWidth
//           value={rule}
//           onChange={(e) => setRule(e.target.value)}
//           onKeyDown={handleAddRule}
//           placeholder="Press Enter to add..."
//         />
//       </div>
//     </div>
//   );
// }

// export default ThirdCard;

// import React from 'react';
// import AnnouncementIcon from '@mui/icons-material/Announcement';
// //import { Button } from '@mui/material';
// //import CloudSyncIcon from '@mui/icons-material/CloudSync';

// function ThirdCard() {
//   return (
//     <div className="p-2 flex flex-col justify-between h-full items-start ">
//       <div className="w-full">
//         <div className="flex items-center justify-between">
//           <h1 className="text-2xl font-semibold">Rules</h1>
//           <div>
//             <AnnouncementIcon />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ThirdCard;




import React, { useState } from 'react';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { TextField, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

function ThirdCard() {
  const [rule, setRule] = useState('');
  const [rules, setRules] = useState([]);

  const handleAddRule = (e) => {
    if (e.key === 'Enter' && rule.trim() !== '') {
      setRules([rule, ...rules]); // Add new rule at the top
      setRule('');
    }
  };

  const handleDeleteRule = (index) => {
    setRules(rules.filter((_, i) => i !== index));
  };

  return (
    <div className="p-4 flex flex-col h-full rounded-lg shadow-lg b text-white">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-semibold">Rules</h1>
        <AnnouncementIcon className="text-white" />
      </div>

      {/* Rules List (Scrollable) */}
      <div className="flex flex-col space-y-2 flex-grow overflow-y-auto max-h-60 pr-2">
        {rules.length > 0 ? (
          rules.map((r, index) => (
            <div key={index} className="flex justify-between items-center px-3 py-2 border border-gray-500 rounded-md">
              <span className="text-white">{r}</span>
              <IconButton size="small" onClick={() => handleDeleteRule(index)} className="text-white">
                <DeleteIcon fontSize="small" className="text-white" />
              </IconButton>
            </div>
          ))
        ) : (
          <p className="text-gray-400">No rules added yet.</p>
        )}
      </div>

      {/* Input Field (Fixed Below) */}
      <div className="mt-4">
        <TextField
          label="Add Rule"
          variant="outlined"
          fullWidth
          value={rule}
          onChange={(e) => setRule(e.target.value)}
          onKeyDown={handleAddRule}
          placeholder="Press Enter to add..."
          InputProps={{
            style: { color: 'white' }, // Ensures the text entered is white
          }}
          InputLabelProps={{
            style: { color: 'white' }, // Label text color
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: 'white' },
              '&:hover fieldset': { borderColor: 'white' },
              '&.Mui-focused fieldset': { borderColor: 'white' },
            },
            '& .MuiInputBase-input': {
              color: 'white', // Ensures the typed text is white
            },
            '& .MuiInputBase-input::placeholder': {
              color: 'white',
              opacity: 1,
            },
          }}
        />
      </div>
    </div>
  );
}

export default ThirdCard;
